/**
 * Geoip redirect functionality.
 *
 * @package   geoip_redirect
 * @author    Mark Shercliff <mark@bareface.agency>
 * @copyright 2016 Bareface
 */
;(function($, Foundation, document, undefined) {
    $(function() {
        var $modal      = $('#geoip-redirect-modal'),
            COOKIE_NAME = 'geoip_redirect';

        if (!$modal.length || document.cookie.indexOf(COOKIE_NAME) > -1) {
            return;
        }

        $modal.foundation('open');

        jQuery('#redirect-close').click(function() {
            var date = new Date();
            date.setTime(date.getTime() + (30*24*60*60*1000));
            document.cookie = COOKIE_NAME + '=1; path=/; expires=' + date.toGMTString();
            location.reload();
        });
    });
})(jQuery, Foundation, document);
